import { useTranslation } from "react-i18next";
import { AnnouncementFormModel } from "../models/AnnouncementFormModel";

export const useInitAnnouncementForm = () => {
	const { t } = useTranslation();

	const defaultValues: Partial<AnnouncementFormModel> = {
		title: "",
		description: "",
		validFrom: "",
		validTo: "",
		recipientRole: undefined,
		faculties: [],
		departments: [],
		studyPrograms: [],
		years: [],
		studyCycles: [],
		targetCompanyIds: [],
	};

	return { defaultValues };
};
